import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import 'default-passive-events'
Vue.use(ElementUI)
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
import wx from "weixin-jsapi";
import VueCropper from 'vue-cropper'
import md5 from 'js-md5'  //引入
Vue.prototype.$md5 = md5;  //定义全局变量
Vue.prototype.$Base64=
Vue.use(VueCropper)
Vue.prototype.$wx = wx;

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
  // locale: localStorage.getItem("lang") || "zh",
  locale:localStorage.getItem("lang") == (undefined || "" || null)
  ? "zh"
  : localStorage.getItem("lang"),
  messages: {
    zh: require("./assets/i18n/zh"),
    en: require("./assets/i18n/en")
  },
  silentTranslationWarn: true
});
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

